import { useCallback } from 'react';

import { useLanguage } from '../../contexts/language';
import { useNoteSaves } from '../../contexts/note-saves';

import { NoteField } from '../note-field';

import styles from './style.module.css';

// One answer of a submitted test, in its review: the item's number and
// wording and the chosen option, with a Note badge when the clinician has
// written one. Opened, it lists every option with the patient's marked, and
// the clinician's note on it. onToggle is given the item's position. The
// badge follows the note as last saved, read from the note saves (#132), so
// it never shows for text not yet stored.
export function ReviewAnswer({ attemptId, answer, options, patientName, open, onToggle }) {
  const { text } = useLanguage();
  const { entryOf } = useNoteSaves();
  const { position, value, label, note } = answer;
  const panel = `review-answer-${ position }`;
  const entry = entryOf({ attemptId, position, initial: note });

  const toggle = useCallback(function() {
    onToggle(position);
  }, [ onToggle, position ]);

  let badge = null;

  if (entry.stored.trim() !== '') {
    badge = <span className={ styles.badge }>{ text.note }</span>;
  }

  const choices = options.map(function(option) {
    let mark = null;
    let className = styles.option;

    if (option.value === value) {
      mark = <span className={ styles.theirs }>{ text.theirAnswer.replace('{name}', patientName) }</span>;
      className = `${ styles.option } ${ styles.chosen }`;
    }

    return (
      <li key={ option.value } className={ className }>
        <span className={ styles.dot } aria-hidden='true'></span>
        <span>{ option.label }</span>

        { mark }
      </li>
    );
  });

  let className = styles.head;

  if (open === true) {
    className = `${ styles.head } ${ styles.open }`;
  }

  return (
    <article className={ styles.answer }>
      <h3 className={ styles.heading }>
        <button className={ className } type='button' aria-expanded={ open } aria-controls={ panel } onClick={ toggle }>
          <span className={ styles.number }>{ `${ position }.` }</span>

          <span className={ styles.lines }>
            <span className={ styles.item }>{ answer.text }</span>

            <span className={ styles.picked }>
              <span>{ label }</span>

              { badge }
            </span>
          </span>

          <span className={ styles.chevron } aria-hidden='true'></span>
        </button>
      </h3>

      <div id={ panel } className={ styles.panel } hidden={ open === false }>
        <ul className={ styles.options }>{ choices }</ul>

        <NoteField
          id={ `review-note-${ position }` }
          label={ text.yourNote }
          placeholder={ text.noteOnAnswer }
          attemptId={ attemptId }
          position={ position }
          initial={ note }
        />
      </div>
    </article>
  );
}
